import { FormulaEditorField } from 'components/FormulaEditor/FormulaEditorField';
import { useRequest } from 'features/request/useRequest';

import { useMemo } from 'react';
import { useForm } from 'react-hook-form';

export const FormulaEditorSample = () => {
    const { control } = useForm();

    const [variablesData] = useRequest<any>({
        requestId: 'catalogOtherCostVariableSelectionItems',
        query: `query catalogOtherCostVariableSelectionItems {
                    catalogOtherCostVariableSelectionItems{
                        totalCount
                        items {
                            uniqueId
                            name
                            entityUniqueId
                            entityName
                            dataSourceId
                            dataSourceName
                            type
                        }
                    }
                }`,
    });

    const sourceObject = useMemo(
        () =>
            variablesData?.catalogOtherCostVariableSelectionItems?.items?.reduce((acc: any, item: any) => {
                if (acc[item.entityName]) {
                    acc[item.entityName].push(item.name);
                } else {
                    acc[item.entityName] = [item.name];
                }

                return acc;
            }, {}),
        [variablesData?.catalogOtherCostVariableSelectionItems?.items],
    );

    return (
        <div style={{ padding: '20px', width: '80%', height: '300px' }}>
            <FormulaEditorField control={control} objectSource={sourceObject} name="formulaEditorDefault" />
        </div>
    );
};

FormulaEditorSample.displayName = 'FormulaEditorSample';
